import { NgStyle } from '@angular/common';
import { Component, DestroyRef, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { V2ButtonComponent, V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';
import { SelectMediaComponent } from '../../../dialogs/shared/select-media/select-media.component';

export interface CardModel {
  headline: string;
  backgroundUrl: string;
  text: string;
  icon: string;
  button: {
    name: string;
    url: string;
  };
}

@Component({
  selector: 'coin-equity-cms-card-item',
  templateUrl: './equity-cms-card-item.component.html',
  styleUrls: ['./equity-cms-card-item.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, V2ButtonComponent, MatFormFieldModule, FormsModule, TranslateModule, V2TextInputComponent]
})
export class EquityCmsCardItemComponent {
  private readonly dialog = inject(MatDialog);
  private readonly destroyRef = inject(DestroyRef);

  @Input() card: CardModel;
  @Input() small: boolean;
  @Input() contentEdit = false;
  @Input() modifiedWidth = false;

  public get iconUrl(): string {
    return `assets/equity/icons/general/${this.card?.icon}.svg`;
  }

  public onButtonClick(button: CardModel['button']): void {
    if (button.url) {
      window.open(button.url, '_blank');
    }
  }

  /**
   * Open popup to set a new image from existing or upload a new one
   * @param item current image that is used in card item
   */
  public editPicture(item: CardModel): void {
    SelectMediaComponent.openDialog(this.dialog, { url: item?.backgroundUrl, mediaType: 'image' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newImage => {
        if (newImage) {
          item.backgroundUrl = newImage.mediaUrl;
        }
      });
  }
}
